export default __webpack_public_path__ + "static/media/bell-icon.b04f5873.svg";